"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var StudentAgreement_1 = require("./parts/StudentAgreement");
var TourReceiptForm_1 = require("./parts/TourReceiptForm");
var model_actions_creators_1 = require("./../../../store/model.actions.creators");
var styles = __importStar(require("./TourReceipt.module.css"));
function mapStateToProps(_a) {
    var model = _a.model;
    return { model: model };
}
var mapDispatchToProps = {
    updateJonsCallback: model_actions_creators_1.updateJson
};
var FormComponent = (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            stateSelected: "TX"
        };
        _this.changeState = _this.changeState.bind(_this);
        return _this;
    }
    FormComponent.prototype.render = function () {
        var isPdf = false;
        if (window.isPdf) {
            isPdf = true;
        }
        return (react_1.default.createElement("div", { id: "tour_receipt", className: styles.containerPosition + " " + styles.breakPage },
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone }),
            react_1.default.createElement("div", { className: styles.pageSize + " " + styles.paddingLeftRight },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(TourReceiptForm_1.TourReceiptComponent, null),
                    react_1.default.createElement(StudentAgreement_1.AsherStudentAgreement, { nextForm: this.props.nextStudentForm }))),
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone })));
    };
    FormComponent.prototype.changeState = function (changeEvent) {
        this.setState({
            stateSelected: changeEvent.target.value
        });
    };
    return FormComponent;
}(react_1.Component));
exports.TourReceiptContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(FormComponent);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG91clJlY2VpcHRDb250YWluZXIuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9Ub3VyUmVjZWlwdC9Ub3VyUmVjZWlwdENvbnRhaW5lci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFzQztBQUN0QywyQ0FBbUM7QUFFbkMsNkRBQThEO0FBRTlELDJEQUE0RDtBQUU1RCxrRkFBa0U7QUFDbEUsK0RBQWtEO0FBRWxELFNBQVMsZUFBZSxDQUFDLEVBQU87UUFBTixnQkFBSztJQUMzQixPQUFPLEVBQUMsS0FBSyxPQUFBLEVBQUMsQ0FBQTtBQUNsQixDQUFDO0FBRUQsSUFBTSxrQkFBa0IsR0FBRztJQUN2QixrQkFBa0IsRUFBRSxtQ0FBVTtDQUNqQyxDQUFBO0FBRUQ7SUFBNEIsaUNBQW1CO0lBQzNDLHVCQUFZLEtBQUs7UUFBakIsWUFDSSxrQkFBTSxLQUFLLENBQUMsU0FLZjtRQUpHLEtBQUksQ0FBQyxLQUFLLEdBQUc7WUFDVCxhQUFhLEVBQUUsSUFBSTtTQUN0QixDQUFBO1FBQ0QsS0FBSSxDQUFDLFdBQVcsR0FBRyxLQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxLQUFJLENBQUMsQ0FBQTs7SUFDbEQsQ0FBQztJQUVELDhCQUFNLEdBQU47UUFDSSxJQUFJLEtBQUssR0FBRyxLQUFLLENBQUE7UUFFakIsSUFBSSxNQUFNLENBQUMsS0FBSyxFQUFFO1lBQ2QsS0FBSyxHQUFHLElBQUksQ0FBQTtTQUNmO1FBRUQsT0FBTyxDQUNILHVDQUFLLEVBQUUsRUFBQyxjQUFjLEVBQUMsU0FBUyxFQUFLLE1BQU0sQ0FBQyxpQkFBaUIsU0FBSSxNQUFNLENBQUMsU0FBVztZQUM5RSxDQUFDLEtBQUssSUFBSSx1Q0FBSyxTQUFTLEVBQUUsZUFBYSxNQUFNLENBQUMsV0FBYSxHQUFRO1lBQ3BFLHVDQUFLLFNBQVMsRUFBSyxNQUFNLENBQUMsUUFBUSxTQUFJLE1BQU0sQ0FBQyxnQkFBa0I7Z0JBQzNEO29CQUNJLDhCQUFDLHNDQUFvQixPQUFHO29CQUN4Qiw4QkFBQyx3Q0FBcUIsSUFBQyxRQUFRLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxlQUFlLEdBQUksQ0FFN0QsQ0FDSjtZQUNMLENBQUMsS0FBSyxJQUFJLHVDQUFLLFNBQVMsRUFBRSxlQUFhLE1BQU0sQ0FBQyxXQUFhLEdBQVEsQ0FDbEUsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQUVELG1DQUFXLEdBQVgsVUFBWSxXQUFXO1FBQ25CLElBQUksQ0FBQyxRQUFRLENBQUM7WUFDVixhQUFhLEVBQUUsV0FBVyxDQUFDLE1BQU0sQ0FBQyxLQUFLO1NBQzFDLENBQUMsQ0FBQTtJQUNOLENBQUM7SUFDTCxvQkFBQztBQUFELENBQUMsQUFwQ0QsQ0FBNEIsaUJBQVMsR0FvQ3BDO0FBRVksUUFBQSxvQkFBb0IsR0FBRyxxQkFBTyxDQUFDLGVBQWUsRUFBRSxrQkFBa0IsQ0FBQyxDQUFDLGFBQWEsQ0FBQyxDQUFBIn0=